import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import './ConfirmableLink.scss';
var ConfirmableLink = /*#__PURE__*/function (_React$Component) {
  function ConfirmableLink(props) {
    var _this;
    _classCallCheck(this, ConfirmableLink);
    _this = _callSuper(this, ConfirmableLink, [props]);
    _this.state = {
      askConfirm: false
    };
    return _this;
  }
  _inherits(ConfirmableLink, _React$Component);
  return _createClass(ConfirmableLink, [{
    key: "handleClickTrigger",
    value: function handleClickTrigger() {
      this.props.onClickTrigger();
      this.setState({
        askConfirm: true
      });
    }
  }, {
    key: "handleClickCancel",
    value: function handleClickCancel() {
      this.props.onClickCancel();
      this.setState({
        askConfirm: false
      });
    }
  }, {
    key: "renderCopy",
    value: function renderCopy() {
      var copy = this.state.askConfirm ? this.props.confirmCopy : this.props.triggerCopy;
      return /*#__PURE__*/React.createElement("div", {
        className: "confirmable-copy ".concat(this.props.copyClassName),
        style: {
          marginRight: this.props.spaceBetween
        }
      }, copy);
    }
  }, {
    key: "renderTrigger",
    value: function renderTrigger() {
      var _this2 = this;
      var className = this.props.linkClassName;
      return /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: "0",
        className: "confirmable-trigger ".concat(className),
        onClick: function onClick() {
          return _this2.handleClickTrigger();
        }
      }, this.props.triggerCTA);
    }
  }, {
    key: "renderConfirmation",
    value: function renderConfirmation() {
      var _this3 = this;
      var spaceBetween = this.props.spaceBetween;
      var className = this.props.linkClassName;
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: "0",
        className: "confirmable-submit ".concat(className),
        onClick: function onClick() {
          return _this3.props.onSubmit();
        }
      }, this.props.confirmCTA), /*#__PURE__*/React.createElement("a", {
        style: {
          marginLeft: spaceBetween
        },
        role: "button",
        tabIndex: "0",
        className: "confirmable-cancel ".concat(className),
        onClick: function onClick() {
          return _this3.handleClickCancel();
        }
      }, this.props.cancelCTA));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "confirmable-link-container"
      }, this.props.showCopy && this.renderCopy(), this.state.askConfirm ? this.renderConfirmation() : this.renderTrigger());
    }
  }]);
}(React.Component);
ConfirmableLink.propTypes = {
  confirmCopy: PropTypes.string,
  triggerCopy: PropTypes.string,
  triggerCTA: PropTypes.string.isRequired,
  confirmCTA: PropTypes.string,
  cancelCTA: PropTypes.string,
  spaceBetween: PropTypes.string,
  linkClassName: PropTypes.string,
  copyClassName: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClickTrigger: PropTypes.func,
  onClickCancel: PropTypes.func,
  showCopy: PropTypes.bool
};
ConfirmableLink.defaultProps = {
  triggerCopy: 'Take this action?',
  confirmCopy: 'Confirm this action?',
  confirmCTA: 'Confirm',
  cancelCTA: 'Cancel',
  spaceBetween: '20px',
  linkClassName: 'medium-weight body-text-2',
  copyClassName: 'normal-weight body-text-2',
  showCopy: true,
  onClickCancel: function onClickCancel() {
    return null;
  },
  onClickTrigger: function onClickTrigger() {
    return null;
  }
};
export default ConfirmableLink;